import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },

  {
    path: '',
    loadComponent: () => import('./layout/shell/shell').then((m) => m.Shell),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'ai',
        loadComponent: () => import('./layout/ai-page/ai-page').then((m) => m.AIPageComponent),
      },
      {
        path: 'customers',
        loadComponent: () => import('./pages/customers/customer-list').then((m) => m.CustomerList),
      },
      {
        path: 'customers/:id',
        loadComponent: () => import('./pages/customers/customer-detail').then((m) => m.CustomerDetail),
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./pages/subscriptions/subscription-list').then((m) => m.SubscriptionList),
      },
      {
        path: 'subscriptions/:id',
        loadComponent: () => import('./pages/subscriptions/subscription-detail').then((m) => m.SubscriptionDetail),
      },
      {
        path: 'demo-requests',
        loadComponent: () => import('./pages/demo-requests/demo-request-list').then((m) => m.DemoRequestList),
      },
      {
        path: 'offers',
        loadComponent: () => import('./pages/offers/offer-list').then((m) => m.OfferList),
      },
      {
        path: 'offers/:id',
        loadComponent: () => import('./pages/offers/offer-detail').then((m) => m.OfferDetail),
      },
      {
        path: 'contracts/:id',
        loadComponent: () => import('./pages/contracts/contract-detail').then((m) => m.ContractDetail),
      },
      {
        path: 'contract-templates',
        loadComponent: () => import('./pages/contract-templates/contract-template-list').then((m) => m.ContractTemplateList),
      },
      {
        path: 'contract-templates/:id',
        loadComponent: () => import('./pages/contract-templates/contract-template-detail').then((m) => m.ContractTemplateDetail),
      },
      {
        path: 'subscription-templates',
        loadComponent: () => import('./pages/subscription-templates/template-list').then((m) => m.TemplateList),
      },
      {
        path: 'subscription-templates/:id',
        loadComponent: () => import('./pages/subscription-templates/template-detail').then((m) => m.TemplateDetail),
      },
      {
        path: 'coupon-templates',
        loadComponent: () => import('./pages/coupon-templates/coupon-template-list').then((m) => m.CouponTemplateList),
      },
      {
        path: 'coupon-templates/:id',
        loadComponent: () => import('./pages/coupon-templates/coupon-template-detail').then((m) => m.CouponTemplateDetail),
      },
      {
        path: 'tickets',
        loadComponent: () => import('./pages/tickets/ticket-list').then((m) => m.TicketList),
      },
      {
        path: 'tickets/:id',
        loadComponent: () => import('./pages/tickets/ticket-detail').then((m) => m.TicketDetail),
      },
      {
        path: 'labels',
        loadComponent: () => import('./pages/labels/label-list').then((m) => m.LabelList),
      },
      {
        path: 'invoices',
        loadComponent: () => import('./pages/invoices/invoice-list').then((m) => m.InvoiceList),
      },
      {
        path: 'notes',
        loadComponent: () => import('./pages/notes/notes-list').then((m) => m.NotesList),
      },
      {
        path: 'integrations',
        loadComponent: () => import('./pages/integrations/integrations-list').then((m) => m.IntegrationsList),
      },
      {
        path: 'payments',
        loadComponent: () => import('./pages/payments/payments-list').then((m) => m.PaymentsList),
      },
      {
        path: 'credits',
        loadComponent: () => import('./pages/credits/credits-list').then((m) => m.CreditsList),
      },
      {
        path: 'agents/analytics',
        loadComponent: () => import('./pages/agents/analytics').then((m) => m.AgentAnalytics),
      },
      {
        path: 'agents/configuration',
        loadComponent: () =>
          import('./pages/agents/configuration/agent-configuration.component').then((m) => m.AgentConfiguration),
      },
      {
        path: 'agents/markdowns',
        loadComponent: () =>
          import('./pages/agents/markdown-file-manager/markdown-file-manager.component').then(
            (m) => m.MarkdownFileManagerComponent,
          ),
      },
      {
        path: 'agents/conversations',
        loadComponent: () =>
          import('./pages/agents/conversations/conversations.component').then((m) => m.AgentConversations),
      },
      {
        path: 'settings/ticket-types',
        loadComponent: () => import('./pages/settings/ticket-types').then((m) => m.TicketTypesPage),
      },
      {
        path: 'settings/company',
        loadComponent: () => import('./pages/settings/company-settings').then((m) => m.CompanySettingsPage),
      },
      {
        path: 'settings/users',
        loadComponent: () => import('./pages/settings/users/user-list').then((m) => m.UserList),
      },
      {
        path: 'settings/asset-types',
        loadComponent: () => import('./pages/settings/asset-types').then((m) => m.AssetTypesPage),
      },
      {
        path: 'settings/email-templates',
        loadComponent: () => import('./pages/settings/email-templates').then((m) => m.EmailTemplatesPage),
      },
      {
        path: 'settings/webhooks',
        loadComponent: () => import('./pages/settings/webhooks').then((m) => m.WebhooksPage),
      },
      {
        path: 'settings/volume-discounts',
        loadComponent: () => import('./pages/settings/volume-discounts').then((m) => m.VolumeDiscountsPage),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile').then((m) => m.Profile),
      },
      {
        path: 'products',
        loadComponent: () => import('./pages/products/product-list').then((m) => m.ProductList),
      },
      {
        path: 'products/:id',
        loadComponent: () => import('./pages/products/product-detail').then((m) => m.ProductDetail),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
